import type { SVGProps } from 'react';
const DawnFlagMV = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MV_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MV_svg__a)">
      <path fill="#F32249" d="M0 0h22v16H0z" />
      <rect width={15.714} height={9.6} x={3.143} y={3.2} fill="#15A04F" rx={0.667} />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12.833 11.647a3.6 3.6 0 0 1-.786.086c-2.024 0-3.666-1.671-3.666-3.733s1.642-3.733 3.666-3.733q.406.001.786.086c-1.647.366-2.88 1.86-2.88 3.647s1.233 3.281 2.88 3.647"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMV;
